import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import config from "../../config/form.json";
import useNotify from "../../utils/useNotify";
import { useNavigate } from "react-router-dom";
import { updateOrg } from "../../services/httpCalls";
import { Form, Row, Button, Col, Typography } from "antd";
import FileUploadCustom from "../onboarding/fileUploadCustom";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import {
  editactive,
  inwardPartner,
  notOps,
  productSelection,
  sayUploadAllDocs,
  showloader,
  newPartnerList,
} from "../../store/gloabalState";
import { showDocsAlreadyUploaded } from "../../utils/onboarding/sole-docs/show-docs-already-uploaded";
import {
  showField,
  NEW_REFACTOR,
} from "../../utils/onboarding/onboardingUtils";

const SoleDocs = ({ handleChange }) => {
  // getting sole docs config
  const configData = config.soleDocs[0];

  // initializing form
  const [form] = Form.useForm();

  // local states
  const [companyType, setCompanyType] = useState("");
  const [refreshDocs, setRefreshDocs] = useState(false);
  const [alreadyuploaded, setAlreadyuploaded] = useState({
    COMPANY_PAN_CARD: false,
    SOLE_PROPRIETER_AADHAR_CARD: false,
    GST_CERTIFICATE: false,
  });
  const [uploadedFileList, setUploadedFileList] = useState({
    COMPANY_PAN_CARD: "",
    GST_CERTIFICATE: "",
    SOLE_PROPRIETER_AADHAR_CARD: "",
  });
  const [uploadedFileLinks, setUploadedFileLinks] = useState({
    COMPANY_PAN_CARD: "",
    GST_CERTIFICATE: "",
    SOLE_PROPRIETER_AADHAR_CARD: "",
  });

  // global states
  const partnerListState = useRecoilValue(newPartnerList);

  // values
  const notOps_ = useRecoilValue(notOps);
  const isEditActive = useRecoilValue(editactive);
  const partnerState = useRecoilValue(inwardPartner);

  // setter/updater
  const setShowLoader = useSetRecoilState(showloader);
  const setDocsUploadTrue = useSetRecoilState(sayUploadAllDocs);

  // states
  const [selectionValue, setSelectionValue] = useRecoilState(productSelection);
  const [showNextMove, setShowNextMove] = useRecoilState(sayUploadAllDocs);

  // constants/binders
  const notify = useNotify();
  const navigate = useNavigate();
  const isUploaded = (arg) => {
    return alreadyuploaded?.[arg] ? alreadyuploaded?.[arg] : false;
  };

  const finalSubmit = async () => {
    notify.success("Org saved as draft!");
    setTimeout(() => {
      navigate("/leads");
    }, 700);
  };

  const next = () => {
    setShowLoader(true);
    if (showNextMove) {
      Cookies.set("currentStage", "6");
      handleChange(6);
    } else {
      notify.error("Please do upload all the documents!");
      setShowLoader(false);
    }
  };

  useEffect(() => {
    showDocsAlreadyUploaded({
      setShowLoader,
      setCompanyType,
      setSelectionValue,
      setAlreadyuploaded,
      setUploadedFileList,
      setUploadedFileLinks,
    });
  }, []);

  useEffect(() => {
    if (selectionValue !== "inward") {
      if (
        alreadyuploaded.SOLE_PROPRIETER_AADHAR_CARD &&
        alreadyuploaded.COMPANY_PAN_CARD &&
        alreadyuploaded.GST_CERTIFICATE
      ) {
        setDocsUploadTrue(true);
      } else {
        setDocsUploadTrue(false);
      }
    }
  }, [alreadyuploaded, refreshDocs]);

  const renderField = (field, index) => {
    const { type, label, name, props, style, tooltip } = field;

    // formatting rules
    field?.rules?.forEach((item) => {
      if (item?.pattern) {
        item.pattern = eval(item?.pattern);
      }
      if (item?.required) {
        item.required = eval(item?.required);
      }
      if (item?.validator) {
        item.validator = eval(item?.validator);
      }
    });

    switch (type) {
      case "FileUploadCustom":
        return (
          <FileUploadCustom
            name={name}
            type={field?.sub_type}
            uploadedFileList={eval(props?.uploadedFileList)}
            uploadedFileLinks={eval(props?.uploadedFileLinks)}
            isUploaded={eval(props?.isUploaded)}
            setRefreshDocs={eval(props?.setRefreshDocs)}
            refresh={eval(props?.refresh)}
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (selectionValue === "inward") setShowNextMove(true);
  }, [selectionValue, setShowNextMove]);

  return (
    <div>
      <div className="heading-container">
        <div className="line-heading"></div>
        <div>
          <Typography.Title level={4}>Upload Documents</Typography.Title>
        </div>
      </div>
      <div style={{ margin: " 0 .5rem .5rem" }}>
        <Typography.Text style={{ color: "#000", fontWeight: "500" }}>
          Note:
        </Typography.Text>{" "}
        <br />
        <Typography.Text
          style={{ color: "#000", fontSize: ".9rem", letterSpacing: ".5px" }}
        >
          Password protected files not allowed
        </Typography.Text>
        <br />
        <Typography.Text
          style={{ color: "#000", fontSize: ".9rem", letterSpacing: ".5px" }}
        >
          Maximum size 10mb
        </Typography.Text>
      </div>
      <Form {...configData.formConfig}>
        <Row gutter={[16, 16]}>
          {configData.fields.map((field, index) => {
            // conditional render
            const isVisible = showField(field.productList, partnerListState);

            const isRefactoredRender = isVisible;

            return (
              isRefactoredRender && (
                <Col key={index} span={field?.Col ? field.Col : 12}>
                  {renderField(field, index)}
                </Col>
              )
            );
          })}
        </Row>
        <div className="fixed_btn_wrap">
          <Button onClick={() => handleChange(2)}>Previous</Button>
          <Button type="primary" style={{ marginLeft: ".5rem" }} onClick={next}>
            Next
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default SoleDocs;
